import { render, staticRenderFns } from "./MacroCategories.vue?vue&type=template&id=116bf405&"
import script from "./MacroCategories.vue?vue&type=script&lang=ts&"
export * from "./MacroCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports